export interface ServiceItem {
  id: string;
  number: string;
  title: string; // '\n' で改行
  description: string;
  tag: string;
}

export const SERVICES: readonly ServiceItem[] = [
  {
    id: 'aws',
    number: '01',
    title: 'AWS 環境の\n設計・構築・移行',
    description:
      'Well-Architected Framework に基づく設計と構築、既存環境からの移行。クラウドコストの最適化と、セキュリティの強化まで。',
    tag: 'AWS 設計・構築・移行',
  },
  {
    id: 'cicd',
    number: '02',
    title: 'CI/CD・\n開発生産性改善',
    description:
      'GitHub Actions などの CI/CD パイプラインの構築・改善。コードレビューの自動化と、デプロイの効率化。',
    tag: '開発生産性',
  },
  {
    id: 'ai-tools',
    number: '03',
    title: 'Claude Code・Kiro\n導入・活用支援',
    description:
      'AI ネイティブな開発フローへの移行支援。チームへの導入設計から、実践コーチングまで伴走します。',
    tag: 'AI 開発ツール',
  },
  {
    id: 'resale',
    number: '04',
    title: 'AWS 再販・\n請求代行',
    description:
      'AWS との契約と請求の窓口を eNEW Studio に。請求は円建てで、お使いのアカウントをそのまま移管できます。請求を見る側が設計も見るので、コストの疑問に構成から答えられます。',
    tag: '再販・請求代行',
  },
];
